(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
 (function () {

    var triggers = document.querySelectorAll('.login-modal-trigger');

    var modal = document.getElementById('login-choice-modal');

    if (!modal) return;


    var backdrop = modal.querySelector('.login-modal__backdrop');

    var closeBtn = modal.querySelector('.login-modal__close');

    var lastFocused = null;


    function openModal() {

      lastFocused = document.activeElement;

      modal.removeAttribute('hidden');

      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });

      closeBtn.focus();

    }


    function closeModal() {

      modal.setAttribute('hidden', '');

      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });

      if (lastFocused) lastFocused.focus();

    }


    triggers.forEach(function (trigger) {

      trigger.addEventListener('click', openModal);

    });


    backdrop.addEventListener('click', closeModal);

    closeBtn.addEventListener('click', closeModal);


    modal.addEventListener('click', function (e) {

      var link = e.target.closest('.login-source-link');

      if (link && link.getAttribute('data-login-source')) {

        e.preventDefault();

        try {

          localStorage.setItem('loginSource', link.getAttribute('data-login-source'));

        } catch (err) {}

        window.location.href = link.getAttribute('href');

      }

    });


    document.addEventListener('keydown', function (e) {

      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();

    });

  })(); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({ note: event.target.value });
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
